import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import ValidarRequest from '../../commons/mappings/validarRequest.mapping';

class ValidarProvider {
  constructor() {
    this.paths = URLConfiguration.paths;
    this.validarRequest = new ValidarRequest();
    this.apiProvider = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
  }

  postValidarCreatePersona = async (datoPersona) => {
    const headers = HeadersMapping.getHeaderService();
    const request = this.validarRequest.postValidarCreatePersona(datoPersona);
    const pathNew = serviceUtil.replaceParamUrl(
      this.paths.simulacionProductosRentas.createPersona,
      {}
    );
    let response = null;
    try {
      response = await this.apiProvider.post(pathNew, request, { headers });
    } catch (error) {
      console.log(error);
    }
    return response;
  };
}

export default ValidarProvider;
